import { LOGIN_ACCENT } from './loginDarkTheme';

export const AUTH_BRANDING_ACCENT = LOGIN_ACCENT;
export const AUTH_BRANDING_DARK = '#0a0a0a';
export const AUTH_BRANDING_SURFACE = 'rgba(13,15,17,0.82)';
export const AUTH_BRANDING_BORDER = 'rgba(255,255,255,0.12)';
export const AUTH_BRANDING_TEXT_PRIMARY = '#f8fafc';
export const AUTH_BRANDING_TEXT_BODY = 'rgba(255,255,255,0.86)';
export const AUTH_BRANDING_TEXT_MUTED = 'rgba(255,255,255,0.74)';

export const ROOMNEXA_APP_STORE_URL = 'https://apps.apple.com/us/app/roomnexa/id6785051843';
export const ROOMNEXA_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.roomnexa.console';

export const AUTH_BRANDING_HERO_STATS = [
  { value: '500+', label: 'Hospitality teams trusting RoomNexa daily' },
  { value: '50+', label: 'Demand channels and OTA connections' },
  { value: '10–250', label: 'Rooms supported by live pricing' },
  { value: '30 Days', label: 'Free trial on website-ready plans' },
];
